module.exports = "<md-toolbar>\r\n\t<span class=\"space\"></span>\r\n\t<span>Tablero de Control</span>\r\n</md-toolbar>\r\n<div class=\"content\">\r\n"


//////////////////
// WEBPACK FOOTER
// C:/Source/Ecim/Ecim.Web/src/app/components/dashboard/dashboard.component.html
// module id = ../../../../../src/app/components/dashboard/dashboard.component.html
// module chunks = main